// Mock data for testing land details page
export const mockLandDetails = {
  "82d8755a-e136-4a47-b27d-dfbc0cd55324": {
    id: "82d8755a-e136-4a47-b27d-dfbc0cd55324",
    title: "Khatta Meetha Farm",
    description: "A well maintained farmland with excellent infrastructure and connectivity",
    overview: "This premium farmland offers excellent investment opportunities with modern infrastructure, clear documentation, and strategic location. Perfect for agricultural activities or future development projects.",
    type: "Plot",
    location: "Bijapur Road",
    address: "Survey No. 123, Bijapur Road, Near Bangalore International Airport, Karnataka 560300",
    price: "21212212",
    area: "31",
    bedrooms: 0,
    bathrooms: 0,
    status: "Available",
    approvalStatus: "approved",
    createdAt: "2025-07-21T18:09:47.512441+00:00",
    updatedAt: "2025-07-21T18:10:32.3482+00:00",

    landDetails: {
      landType: "PLOT",
      projectName: "Khatta Meetha Farm Project"
    },

    infrastructure: {
      fencing: "Yes",
      soilType: "Red/Black",
      electricityConnection: "Available",
      waterSupply: "YES",
      approachRoad: "30 ft",
      borewell: "1",
      sewageConnection: "YES",
      floorsAllowed: "YES",
      well: "NO",
      canal: "NO"
    },

    locationHighlights: {
      nearbyHospitals: "2 km from City Hospital",
      nearbySchools: "1 km from ABC School",
      nearbyHotels: "500m from Hotel XYZ",
      nearbyShopping: "1.5 km from Shopping Mall",
      cityConnectivity: "Well connected to main city"
    },

    keyFeatures: {
      totalAcres: "5.2",
      greenSpaces: "40%",
      thematicGardens: "3",
      embankmentParks: "2",
      treesAndShrubs: "500+",
      totalPlots: "120",
      treeAvenues: "4",
      clubhouseArea: "5000 sq ft",
      roadNetwork: "Internal roads",
      roadWidth: "30 ft"
    },

    amenities: [
      "Security",
      "Park",
      "Fencing",
      "Road Access",
      "Electricity",
      "Water Supply",
      "Clubhouse",
      "Swimming Pool"
    ],

    services: [
      "Property Management",
      "Maintenance",
      "Security Services",
      "Landscaping"
    ],

    configurations: [
      {
        size: "30X40",
        sba: "1200"
      },
      {
        size: "40X60", 
        sba: "2400"
      },
      {
        size: "50X80",
        sba: "4000"
      }
    ],

    images: [
      "https://plus.unsplash.com/premium_photo-1669227514138-d5e43441b5e7?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "https://images.unsplash.com/photo-1461175827210-5ceac3e39dd2?q=80&w=1933&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "https://images.unsplash.com/photo-1500382017468-9049fed747ef?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    ],

    documents: [
      {
        id: "doc-uuid-1",
        name: "property_deed.pdf",
        filePath: "properties/82d8755a-e136-4a47-b27d-dfbc0cd55324/documents/property_deed.pdf",
        fileSize: 2048576,
        fileType: "application/pdf",
        uploadedAt: "2025-07-21T18:09:47.512441+00:00",
        isPublic: true
      },
      {
        id: "doc-uuid-2",
        name: "survey_report.pdf",
        filePath: "properties/82d8755a-e136-4a47-b27d-dfbc0cd55324/documents/survey_report.pdf",
        fileSize: 1024768,
        fileType: "application/pdf",
        uploadedAt: "2025-07-21T18:09:47.512441+00:00",
        isPublic: false
      }
    ],

    ownerId: "owner-uuid",
    agentId: "agent-uuid"
  },

  // Additional sample lands for testing
  "sample-land-2": {
    id: "sample-land-2",
    title: "Sunrise Plots",
    description: "Premium residential plots with modern amenities",
    overview: "Located in a prime area with excellent connectivity and infrastructure.",
    type: "Residential",
    location: "Mysore Road",
    address: "Mysore Road, Bangalore",
    price: "15000000",
    area: "2400",
    status: "Available",
    landDetails: { landType: "RESIDENTIAL", projectName: "Sunrise Heights" },
    infrastructure: { fencing: "Yes", electricityConnection: "Available", waterSupply: "YES" },
    amenities: ["Security", "Park", "Road Access"],
    services: ["Maintenance"],
    images: ["https://images.unsplash.com/photo-1500382017468-9049fed747ef?q=80&w=1932&auto=format&fit=crop"],
    documents: []
  },

  "sample-land-3": {
    id: "sample-land-3",
    title: "Heritage Farmland",
    description: "Traditional farmland with heritage value",
    overview: "Historic farmland with traditional farming practices and heritage significance.",
    type: "Agricultural",
    location: "Kanakapura Road",
    address: "Kanakapura Road, Bangalore",
    price: "8500000",
    area: "5000",
    status: "Available",
    landDetails: { landType: "AGRICULTURAL", projectName: "Heritage Farms" },
    infrastructure: { fencing: "Partial", electricityConnection: "Available", waterSupply: "YES" },
    amenities: ["Well", "Storage", "Road Access"],
    services: ["Agricultural Support"],
    images: ["https://images.unsplash.com/photo-1461175827210-5ceac3e39dd2?q=80&w=1933&auto=format&fit=crop"],
    documents: []
  },

  "sample-land-4": {
    id: "sample-land-4",
    title: "Golden Fields",
    description: "Premium agricultural land with modern facilities",
    overview: "Modern agricultural land with advanced irrigation and farming facilities.",
    type: "Agricultural",
    location: "Tumkur Road",
    address: "Tumkur Road, Bangalore",
    price: "12000000",
    area: "7500",
    status: "Available",
    landDetails: { landType: "AGRICULTURAL", projectName: "Golden Fields Estate" },
    infrastructure: { fencing: "Yes", electricityConnection: "Available", waterSupply: "YES" },
    amenities: ["Irrigation", "Storage", "Processing Unit"],
    services: ["Farm Management", "Technical Support"],
    images: ["https://images.unsplash.com/photo-1500382017468-9049fed747ef?q=80&w=1932&auto=format&fit=crop"],
    documents: []
  }
};

// Function to get mock land details by ID
export const getMockLandDetails = (id) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const landData = mockLandDetails[id];
      if (landData) {
        resolve({
          success: true,
          data: landData
        });
      } else {
        reject({
          response: {
            data: {
              error: "Land listing not found",
              message: "The requested land listing does not exist"
            }
          }
        });
      }
    }, 1000); // Simulate API delay
  });
};
